// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import isEmpty from 'lodash/isEmpty'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { i18n } from '../../index'
import IncentiveProducts from './IncentiveProducts'
import ThumbsUpServices from './ThumbsUpServices'
import type { Incentives } from './types'
import css from './IncentivesPanel.css'
type State = {
  incentiveProducts: Array<Incentives>
  thumbsUpItems: Array<Incentives>
  salesIncentiveUnit: string | null | undefined
}
type Props = {
  currentEmployeeId: string
  stationId: string
  dailyManagement: Record<string, any>
  setStationUnits: (...args: Array<any>) => any
  currentUserNote: string
  date: string
  category: string
}

class SalesManagement extends React.Component<Props, State> {
  state = {
    incentiveProducts: [],
    thumbsUpItems: [],
    salesIncentiveUnit: null,
  }
  registerIncentiveSale = (
    onMutate: (...args: Array<any>) => any,
    salesIncentiveProductId: string | null | undefined,
    name?: string,
    amount: number,
  ) => {
    const { currentEmployeeId, date, stationId } = this.props
    const { salesIncentiveUnit: unit } = this.state
    const variables = {
      userId: currentEmployeeId,
      amount,
      unit,
      salesIncentiveProductId,
      name,
      date,
      stationId,
    }
    onMutate({
      variables,
    })
  }
  registerThumbUp = (onMutate: (...args: Array<any>) => any, thumbsUpItemId: string) => {
    const { currentEmployeeId, date, stationId } = this.props
    const variables = {
      userId: currentEmployeeId,
      thumbsUpItemId,
      date,
      stationId,
    }
    onMutate({
      variables,
    })
  }

  componentDidMount() {
    const { dailyManagement, setStationUnits } = this.props
    const thumbsUpItems = !isEmpty(dailyManagement) ? dailyManagement.thumbsUpItems : []
    const salesIncentiveUnit = !isEmpty(dailyManagement) ? dailyManagement.salesIncentiveUnit : null
    const incentiveProducts = !isEmpty(dailyManagement) ? dailyManagement.salesIncentiveProducts : null
    this.setState({
      thumbsUpItems,
      salesIncentiveUnit,
      incentiveProducts,
    })
    setStationUnits(salesIncentiveUnit)
  }

  render() {
    const { stationId, currentEmployeeId, date, category } = this.props
    const { thumbsUpItems, salesIncentiveUnit, incentiveProducts } = this.state
    const isPcs = 'Pieces' === salesIncentiveUnit
    const getStaffingPlanVariables = {
      stationId,
      date: date,
      mode: 'Day',
    }
    return (
      <Paper className={css.salesManagement}>
        <div className={css.buttonRow}>
          <Typography variant='subtitle1' className={css.label}>
            {i18n.t('employeeCard.addSales')}
          </Typography>
          <div className={css.incentiveProducts}>
            <span id={'#aloitteellinen-myynti'} />
            <IncentiveProducts
              salesIncentiveProducts={incentiveProducts}
              isPcs={isPcs}
              unit={salesIncentiveUnit}
              variables={getStaffingPlanVariables}
              registerIncentiveSale={this.registerIncentiveSale}
              stationId={stationId}
              category={category}
              date={date}
            />
          </div>
        </div>
        <div className={css.buttonRow}>
          <Typography variant='subtitle1' className={css.label}>
            {i18n.t('employeeCard.addServices')}
          </Typography>
          <div className={css.thumbsUpProducts}>
            <span id={'#peukutettavat-palvelut'} />
            <ThumbsUpServices
              variables={getStaffingPlanVariables}
              thumbsUpItems={thumbsUpItems}
              currentEmployeeId={currentEmployeeId}
              registerThumbUp={this.registerThumbUp}
              date={date}
              stationId={stationId}
            />
          </div>
        </div>
      </Paper>
    )
  }
}

export default SalesManagement
